import store from "../store";

export default function (to, from , next) {
    if (store.getters.user) {
        next()
    }else{
        next('/login?loginError=true')
    }
}


// WEBPACK FOOTER //
// ./src/router/auth-guard.js